import Auth from '@js/plugins/auth';

export default {
    computed: {
        canManageSettings() {
            return Auth.hasPermissionTo('franchise_manage_settings');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/settings-permission.js